import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Testimonials from '../sections/Testimonials';
import usePageMeta from '../hooks/usePageMeta';
import useLangPrefix from '../hooks/useLangPrefix';

function TestimonialsPage() {
  const { t } = useTranslation();
  const langPrefix = useLangPrefix();

  usePageMeta({
    title: `${t('testimonials.heading')} | Marwa Hawshar`,
    description: t('testimonials.subheading'),
    path: `${langPrefix}/testimonials`,
  });

  return (
    <>
      <h1 className="visually-hidden">{t('testimonials.heading')}</h1>
      <Testimonials />
      <section className="py-5 py-lg-6 bg-light border-top text-center">
        <div className="container">
          <h2 className="h4 fw-semibold text-navy mb-2">{t('testimonials.pageCtaHeading')}</h2>
          <p className="text-muted mb-4">{t('testimonials.pageCtaSubheading')}</p>
          <Link to={`${langPrefix}/contact`} className="btn btn-navy">
            {t('nav.contact')}
          </Link>
        </div>
      </section>
    </>
  );
}

export default TestimonialsPage;
